import { render, staticRenderFns } from "./TimerEventDetail.vue?vue&type=template&id=2f752ef4&"
import script from "./TimerEventDetail.vue?vue&type=script&lang=js&"
export * from "./TimerEventDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f752ef4')) {
      api.createRecord('2f752ef4', component.options)
    } else {
      api.reload('2f752ef4', component.options)
    }
    module.hot.accept("./TimerEventDetail.vue?vue&type=template&id=2f752ef4&", function () {
      api.rerender('2f752ef4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/gva-wfd/components/DetailPanel/TimerEventDetail.vue"
export default component.exports